import type { AudioSource } from "@yetric/audioplayer";
import { getPodcastImage, ImageSizes } from "@/core/helpers";

/** An audio source that also says which podcast it belongs to, for settings kept per show */
export type PodcastAudioSource = AudioSource & { podcastId: number };

/** What the audio player needs to load an episode */

export const toAudioSource = (episode: Episode, podcast: Podcast): PodcastAudioSource => ({
    podcastId: podcast.id,
    id: episode.id.toString(),
    src: episode.sound,
    title: episode.title,
    artist: podcast.name,
    album: podcast.name,
    artwork: getPodcastImage(podcast, ImageSizes.Medium),
});
